<template>
  <div id="wizard-steps" class="wizard-steps lg:tw-mt-40 lg:tw-mx-auto tw-relative">
    <span class="tw-absolute"></span>
    <div
      v-for="(step, index) in steps"
      class="step tw-flex tw-flex-col tw-items-center tw-absolute"
      :id="`step-${index}`"
      :class="{ disabled: maxIndex < index }"
    >
      <!-- <div class="tw-flex tw-items-center">
        <span
          @click="goToRoute(index)"
          class="circle tw-relative tw-bg-white tw-flex tw-justify-center tw-items-center tw-cursor-pointer"
          :class="{
            active: stepIsActive(step),
            'cursor-pointer': stepIsAllowed(index),
            'cursor-not-allowed': !stepIsAllowed(index),
            'active-later': stepIsActivated(index),
          }"
        >
          <span class="number">{{ index + 1 }}</span>
        </span>
      </div> -->
      <div class="load-line">
        <div id="load-line" class="load-line-red" :class="{load_red: stepIsActivated(index - 1)}"></div>
      </div>
    </div>
    <div v-if="routeIndex($route.name) > 0" @click="backRoute(routeIndex($route.name)-1)" class="back-step tw-mt-8 tw-cursor-pointer tw-flex tw-items-center">
      <img src="/img/icons/icon-back.webp"/>
      <span class="tw-pl-4 tw-font-semibold">Atrás</span>
    </div> 
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { eventBus } from "../../vue";

export default {
  data() {
    return {
      maxIndex: 0,
      stepSelected: 0,
      indexStep: 0,
    };
  },

  computed: {
    ...mapGetters({
      steps: "getRoutes",
    }),
  },

  methods: {
    stepIsActive(step) {
      return this.$route.name === step.name;
    },
    stepIsActivated(step) {
      return this.stepSelected > step;
    },
    stepIsAllowed(index) {
      return index <= this.maxIndex;
    },
    backRoute(index) {
      if (this.stepIsAllowed(index)) {
        this.$router.push(`/simular-inversion/${this.steps[index].path}`).catch(() => {});
      }
    },
    routeIndex(name){
      switch(name){
        case 'Direction':
          return 0;
          break;
        case 'typeApartment':
          return 1;
          break; 
        case 'Size':
          return 2;
          break;
        case 'GroundFloor':
          return 3;
          break;
        case 'Occupied':
          return 4;
          break;  
        case 'Features':
          return 5;
          break;
        case 'State':
          return 6;
          break;
        case 'SaleState':
          return 7;
          break;
        case 'Burdened':
          return 8;
          break;
        case 'PersonalForm':
          return 9;
          break;
      }
    }

  },

  created() {
    eventBus.$on("routechanged", (route) => {
      const index = this.steps.findIndex((s) => s.name === route.name);
      this.stepSelected = index;
      if (index > this.maxIndex) {
        this.maxIndex = index;
      }
    });
  },
};
</script>

<style lang="scss">
@import '../../../sass/variables';
.dotted-line {
  width: 90%;
  height: 1px;
  top: 12px;
  left: 7%;
  right: 7%;
  background: linear-gradient(to right, #818fa6 33%, rgba(255, 255, 255, 0) 0%);
  background-position: bottom;
  background-size: 5px 1px;
  background-repeat: repeat-x;
  z-index: 10;
  @media (min-width: 1024px) {
    background-size: 8px 1px;
    top: 22px;
  }
}
.wizard-steps {
  width: 95%;
  max-width: 1400px;
  top: 0;
  @media (max-width: $lg) {
    width: 92%;
    left: 20px;
    top: 65px;
  }
  @media(max-width: 610px){
    width: 90%;
  }
  @media(max-width: 450px){
    width: 88%;
  }
  @media(max-width: 370px){
    width: 86%;
  }

  .step {
    z-index: 20;
    width: 12.5%;
    color: #535b6c;
    .circle {
      border-width: 0.5px;
      border-style: solid;
      border-color: #535b6c;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      font-size: 16px;
      font-weight: 400;
      color: inherit;
      transition: background 2s, color 2s, border-color 2s;
      @media (min-width: 1024px) {
        width: 43px;
        height: 43px;
        font-size: 22px;
      }
      .number {
        color: inherit;
        transition: color 2s;
      }
      &.active {
        background: #be0b22;
        border-color: #be0b22;
        .number {
          color: white;
        }
        &::after {
          content: "";
          border-radius: 50%;
          border: 2px solid #be0b22;
          width: 51px;
          height: 51px;
          position: absolute;
          bottom: -5px;
          left: -5px;

          @media (max-width: 1024px) {
            width: 32px;
            height: 32px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }

      &.active-later {
        background: #be0b22;
        border-color: #be0b22;
        .number {
          color: white;
        }
      }
    }
    .step-name {
      font-size: 10px;
      color: inherit;
      font-weight: 400;
      font-size: 12px;
      &.active {
        color: #be0b22;
      }
    }
    .step-value {
      font-size: 14px;
      max-width: 140px;
      font-weight: 600;
      color: $primary;
      line-height: 1.22;
    }
    &.disabled {
      color: #818fa6;
      .circle {
        border-color: #b1b8c8;
      }
    }
  }
  @for $i from 0 through 9 {
    #step-#{$i + 1} {
      left: calc(95% / 10 * #{$i});
      @media(max-width: $lg){
        left: calc(100% / 10 * #{$i});
      }
    }
  }
}

.back-step{
  color: $primary;
  @media(max-width: $lg){
    display: none;
  }
}

.count-steps,
.back-step{
  font-family: $font-nunito-sans;
  font-size: 16px !important;
  font-weight: 600;
}

.is_red {
  background-color: $primary;
}

.load-line {
  background-color: $color-grey-6;
  width: 100%;
  height: 2px;
}

.load-line-red {
  height: 100%;
}

.load_red {
  background-color: $primary;
  animation: loadWidth 2s;
}

.load_red_back {
  background-color: $primary;
  animation: backStep 2s;
}

@keyframes loadWidth {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}

@keyframes backStep {
  from {
    width: 100%;
  }
  to {
    width: 0;
  }
}

</style>
  